import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthHttpClientService } from '@service/auth-http-client.service';
import { CampaignDto, DraftCampaignDto, ScheduledCampaignDto } from '@dto/campaign/campaign.dto';
import { CampaignByProductIdDto } from '@dto/campaign/campaign-by-product-id.dto';
import { ChatCodesByProductIdsDto } from '@dto/campaign/chat-codes-by-product-ids.dto';

@Injectable({
  providedIn: 'any',
})
export class CampaignService {
  private readonly url: string = environment.tmnBackApi;

  constructor(private readonly http: AuthHttpClientService) {}

  getChatCodeFromProductIds(): Observable<ChatCodesByProductIdsDto> {
    return this.http.get<ChatCodesByProductIdsDto>(
      `${this.url}/products/teams/chat-singles`
    );
  }
  getCampaignByProductIds(productIds: string[]): Observable<CampaignByProductIdDto> {
    return this.http.get<CampaignByProductIdDto>(
          `${this.url}/teams/campaigns?productIds=${productIds.join(',')}`
        ).pipe(map(this.transformCampaigns));
  }

  sendImmediateCampaign(campaignData: CampaignDto): Observable<void> {
    return this.http.post<void>(
      `${this.url}/teams/campaigns/immediate`,
      campaignData
    );
  }

  saveCampaign(campaignData: DraftCampaignDto): Observable<void> {
    return this.http.post<void>(
    `${this.url}/teams/campaigns/draft`,
     campaignData
     );
  }

  scheduleCampaign(campaignData: ScheduledCampaignDto): Observable<void> {
     return this.http.post<void>(
       `${this.url}/teams/campaigns/scheduled`,
       campaignData
     );
  }

  deleteCampaign(campaignId: string): Observable<void> {
     return this.http.delete<void>(
       `${this.url}/teams/campaigns/${campaignId}`
     );
  }

  private transformCampaigns(response: CampaignByProductIdDto): CampaignByProductIdDto {
    Object.keys(response).forEach(productId => {
      response[productId] = response[productId].map(campaign => ({
        ...campaign,
        status: campaign.status === 'SCHEDULED' && Date.now() > campaign.scheduledAt! ? 'PROCESSING' : campaign.status, // If the campaign is still in SCHEDULED status but the scheduled date has passed, we consider it as PROCESSING for display purposes
      }));
    });
    return response;
  }
}
